(($) => {

  
 $(document).ready(function ($) {
   
 // quick-add buttons
	document.querySelectorAll('.quick-add-wrapper').forEach(item => {
		new product_ProductModule(item)
  	});
   
     

 }); // ready document
})(jQuery); // end 
